<template>
  <i class="icon togo-icon" :class="iconClass"></i>
</template>

<script>
const Icon = {
  name: 'Icon',

  props: {
    kind: {
      type: String
    },
    size: {
      type: String,
      validator(value) {
        return ['lg', '2x', '3x', '4x', '5x'].indexOf(value) > -1;
      }
    }
  },

  computed: {
    iconClass() {
      const classes = {};

      if (this.kind) {
        classes[`togo-icon-${this.kind}`] = true;
      }

      if (this.size) {
        classes[`togo-icon-${this.size}`] = true;
      }

      return classes;
    }
  }
};

export default Icon;
</script>
